import React, { Component } from 'react';
import 'bootstrap/dist/css/bootstrap.css';
import './css/App.css';
import GlobalEmitter from './GlobalEmitter';
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import 'react-select/dist/react-select.css';
import 'react-image-crop/dist/ReactCrop.css';

import { Router } from 'react-router';
import PropTypes from 'prop-types'

import en from 'react-intl/locale-data/en';
import th from 'react-intl/locale-data/th';
import ja from 'react-intl/locale-data/ja';
import { IntlProvider, addLocaleData } from 'react-intl';
import Loading from './pages/Loading';
var Storage = require('store');

let locale = Storage.get("locale");
if (!locale) {
  Storage.set("locale", "ja");
  locale = "ja";
}
//load initial locale
let i18nConfigs = {
  "th": require('./i18n/th.json'),
  "en": require('./i18n/en.json'),
  "ja": require('./i18n/ja.json')
}

addLocaleData([...en, ...th, ...ja]);

class App extends Component {
  static propTypes = {
    history: PropTypes.object.isRequired,
    routes: PropTypes.element.isRequired,
  };

  constructor(props) {
    super(props);
    this.state = {
      locale: locale,
      messages: i18nConfigs[locale].messages,
      loadingMessage: null,
      lock: false
    }
  }

  componentDidMount() {
    let locale = Storage.get("locale");
    this.setState({
      locale: locale,
      messages: i18nConfigs[locale].messages
    });

    GlobalEmitter.on(GlobalEmitter.CHANGE_LANGUAGE, (new_locale) => {
      if (!i18nConfigs[new_locale]) {
        console.warn(new_locale, "is not a valid locale");
        return;
      }
      this.setState({
        locale: new_locale,
        messages: i18nConfigs[new_locale].messages
      });
    });

    GlobalEmitter.on(GlobalEmitter.LOADING, () => {
      this.setState({
        loading: true
      })
    });

    GlobalEmitter.on(GlobalEmitter.UPDATE_LOADING_STATUS, (payload) => {
      this.setState({
        loading: true,
        loadingMessage: payload
      });
    });

    GlobalEmitter.on(GlobalEmitter.END_LOADING, () => {
      this.setState({
        loading: false,
        loadingMessage: null
      });
    });

    

  }

  render() {
    let { loadingMessage } = this.state;
    return (
      <div>
        <IntlProvider
          locale={this.state.locale}
          messages={this.state.messages}>

          <div>
            {this.state.loading && <Loading message={loadingMessage} />}
          </div>
        </IntlProvider>

        <div className={this.state.loading ? "blur" : "app"}>

          <div >
            <IntlProvider
              locale={this.state.locale}
              messages={this.state.messages}>
              <Router
                routes={this.props.routes}
                history={this.props.history} />
            </IntlProvider>
          </div>

        </div>
      </div>
    );
  }
}
export default App;


// WEBPACK FOOTER //
// ./src/App.js